import { cn, focusRing } from "@simpro/ui";
import { useQuery } from "@tanstack/react-query";
import { Phone } from "lucide-react";
import { salonProfileQuery } from "@/features/salon";

/**
 * In place of Add, for a service no stylist does online (see `useUnstaffedServices`): the salon's
 * number as a "Call to book" pill, named with the service, or a quiet "By phone only" while the number
 * is unknown.
 */
export function CallToBook({ serviceName, onInk = false }: { serviceName: string; onInk?: boolean }) {
  const { data: salon } = useQuery(salonProfileQuery());
  const phone = salon?.branch?.phone;
  if (!phone) return <span className="text-sm text-subtle">By phone only</span>;
  return (
    <a
      href={`tel:${phone}`}
      aria-label={`Call to book ${serviceName}`}
      className={cn(
        "inline-flex h-10 shrink-0 items-center gap-1.5 rounded-full px-4 text-sm font-semibold ring-[1.5px] ring-inset transition-colors",
        onInk ? "text-on-bar ring-sage hover:bg-sage-tint hover:text-heading" : "text-subtle ring-edge hover:bg-muted-bg hover:text-heading",
        focusRing,
      )}
    >
      <Phone className="size-4" aria-hidden />
      Call to book
    </a>
  );
}
